import "../style/page/ProductOrderpage.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { pharmacyrequest, pharmacytrackorder } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
import PharmacyRequestForm from "../form/pharmacynew/pharmacyrequestform";
import { useNavigate } from "react-router-dom";
import noimage from "../../assets/images/noimage.png";
import pdf from "../../assets/images/pdf.png";
import downloadimage from "../../assets/images/downloadimage.png";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

function Requestviaprescription(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const formpage = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [trackorderidp, settrackorderidp] = useState("");
  const [trackorderstatep, settrackorderstatep] = useState(false);
  const locationid = useSelector(
    (state) => state.counter.loginuser_location_id
  );
  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );
  const [deliveryType, setDeliveryType] = useState("all");
  const [timeString, settimeString] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const [pharmacyOrderData, setPharmacyOrderData] = useState(true);

  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: pharmacyrequest,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            sample_invoice_requested: "False",
            bill_request_given: "False",
            proceed_payment: "False",
            request_via_prescrip: "True",
            order_list: "false",
            deliveryType: deliveryType,
            branch: branches,
          },
        })
          .then((res) => {
            console.log(res, "testing");
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: pharmacyrequest,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          // sample_invoice_requested:'False',
          bill_request_given: "False",
          proceed_payment: "False",
          invoice_given: "request_via_pres",
          order_list: "false",
          deliveryType: deliveryType,
          branch: branches,
        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    productstate,
    deliveryType,
    branches,
  ]);

  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id));
    dispatch(productorder("Edit"));
    formpage("/requestviaprescriptionform");
  };

  const handle_remove_from_order = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to remove this order from this table",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove order.",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "put",
          url: pharmacyrequest + id + "/",
          data: {
            // remove_from_order: true,
            // deny_proceed_to_pay: true
            status: "Delete",
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            props.popuptext("Order removed from table");
            console.log(res, "res");
            setPharmacyOrderData(!pharmacyOrderData);
          })
          .catch((error) => {
            props.popuptext("Updation failed");
            setPharmacyOrderData(!pharmacyOrderData);
          });
      }
    });
  };
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original, "dfjsfkjshk");
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id}
              >
                {row.row.original.id}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Delivery type",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.request_from_hospital == true
                    ? "Hospital"
                    : "Home"
                }
              >
                {row.row.original.request_from_hospital == true
                  ? "Hospital"
                  : "Home"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {String(row.row.original.patient.p_uhid)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Prescription upload",
        accessor: "",
        Cell: (row) => {
          return (
            // <>
            //   {row.row.original.upload_prescription &&
            //     row.row.original.upload_prescription.length > 0 ? (
            //     row.row.original.upload_prescription.map((ele) => {
            //       {/* console.log(ele,"testajh") */ }
            //       return (
            //         <>
            //           <a href={ele ? ele : noimage} target="_blank">
            //             <img
            //               style={{
            //                 height: "2.5rem",
            //                 width: "2.5rem",
            //                 borderRadius: "50%",
            //                 margin: "4px",
            //               }}
            //               src={ele ? ele : noimage1}
            //             ></img>
            //           </a>
            //         </>
            //       );
            //     })
            //   ) : (
            //     <>
            //       <a href={noimage} target="_blank">
            //         <img
            //           style={{
            //             height: "2.5rem",
            //             width: "2.5rem",
            //             borderRadius: "50%",
            //             margin: "4px",
            //           }}
            //           src={noimage1}
            //         ></img>
            //       </a>
            //     </>
            //   )}
            // </>
            <>
              {row.row.original.upload_prescription &&
              row.row.original.upload_prescription.length > 0 ? (
                row.row.original.upload_prescription.map((ele) => {
                  const isHEIC = ele && ele.toLowerCase().endsWith(".heic");
                  return (
                    <a href={ele} target="_blank" key={ele}>
                      <img
                        style={{
                          height: "2.5rem",
                          width: "2.5rem",
                          borderRadius: "50%",
                          margin: "4px",
                        }}
                        src={isHEIC ? downloadimage : ele}
                        alt="Prescription"
                      />
                    </a>
                  );
                })
              ) : (
                <a href={noimage} target="_blank">
                  <img
                    style={{
                      height: "2.5rem",
                      width: "2.5rem",
                      borderRadius: "50%",
                      margin: "4px",
                    }}
                    src={noimage1}
                    alt="No Prescription"
                  />
                </a>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "Total Amount",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.total_amount}
      //         >
      //           {parseFloat(row.row.original.total_amount).toFixed(2)!="NaN"?parseFloat(row.row.original.total_amount).toFixed(2):"--"}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Location Range",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.location_range != null
                  ? row.row.original.address.location_range + " Km"
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Notes",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.request_presc_notes}
              >
                {row.row.original.request_presc_notes == null
                  ? "--"
                  : row.row.original.request_presc_notes}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },
      {
        Header: "Remove from orders",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  style={{ width: "70px" }}
                  class="btn btn-danger btn-sm edit"
                  disabled={
                    row.row.original.proceed_payment == false ? false : true
                  }
                  onClick={(e) => {
                    handle_remove_from_order(row.row.original.id);
                    // dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  {/* <i class="bi bi-pencil-fill"></i>  */}
                  Remove
                </button>
              </div>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => {
                    dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };

  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Request Via Prescription</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Request Via Prescription</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div
                    class="input-group rounded mr-2 "
                    style={{
                      width: "250px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <p className="mb-0">Select Delivery type</p>
                    <select
                      class="form-select"
                      value={deliveryType}
                      name="status"
                      onChange={(e) => {
                        setDeliveryType(e.target.value);
                      }}
                    >
                      <option selected disabled value="">
                        Filter By Delivery type...
                      </option>
                      <option value={"all"}>All</option>
                      <option value={true}>Hospital</option>
                      <option value={false}>Home</option>
                    </select>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    stateid={"1"}
                    settrackorderidp={settrackorderidp}
                    settrackorderstatep={settrackorderstatep}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {/* {productstate == "Edit" ? (
        <PharmacyRequestForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )} */}
    </>
  );
}

export default Requestviaprescription;
